export enum CodeSnippetLanguages {
    GRAPHQL = "graphql",
    JSON = "json",
    SWIFT = "clike",
    KOTLIN = "clike",
    MARKUP = "markup",
    JAVASCRIPT = "javascript",
    JAVA = "clike",
    BASH = "bash"
}
